import { JobCancellationDashboardParams } from "src/models/dashboard.models";

import API_URL from "./apiConfig/api.config";
import handleResponse from "./apiConfig/api.response.service";
import apiCall from "./apiConfig/apiCall.config";

export async function getDashBoardData() {
  return await apiCall.get(API_URL.DASHBOARD.GET_DASHBOARD_DATA);
}

export const getJobRedirection = async (
  payload: { [key: string]: string | number | number[] } | undefined
) => {
  const res = await apiCall.get(API_URL.DASHBOARD.JOB_REDIRECTION, payload);
  const responseData = handleResponse(res);
  if (responseData?.ok) {
    return responseData?.data;
  } else {
    return responseData;
  }
};

export async function getOfficeJobCancellationList(
  params?: JobCancellationDashboardParams
) {
  return await apiCall.get(API_URL.DASHBOARD.OFFICE_JOB_CANCELLATION, params);
}

export async function getProfessionalJobCancellationList(
  params?: JobCancellationDashboardParams
) {
  return await apiCall.get(
    API_URL.DASHBOARD.PROFESSIONAL_JOB_CANCELLATION,
    params
  );
}
